import { render, staticRenderFns } from "./UserPhone.vue?vue&type=template&id=4b2ba4a0&scoped=true"
import script from "./UserPhone.vue?vue&type=script&lang=js"
export * from "./UserPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ba4a0",
  null
  
)

export default component.exports